function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import useDeferredApi from "./useDeferredApi.js";
import { ApiContext } from "./ApiBootstrap.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Does not render children until the deferred API is resolved.
 */
export var DeferredApiBootstrap = /*#__PURE__*/React.memo(_ref => {
  var children = _ref.children,
    onError = _ref.onError,
    widget = _ref.widget;
  var _useDeferredApi = useDeferredApi(widget),
    _useDeferredApi2 = _slicedToArray(_useDeferredApi, 2),
    api = _useDeferredApi2[0],
    apiError = _useDeferredApi2[1];
  if (apiError != null) {
    onError === null || onError === void 0 || onError(apiError);
    return null;
  }
  if (api == null) {
    // Still waiting for the API to load
    return null;
  }
  return /*#__PURE__*/_jsx(ApiContext.Provider, {
    value: api,
    children: children
  });
});
DeferredApiBootstrap.displayName = 'DeferredApiBootstrap';
export default DeferredApiBootstrap;
//# sourceMappingURL=DeferredApiBootstrap.js.map